export const GET_SUPERFUND_DATA_QUERY = `
  query superFundList {
        superFundList {
            superfundName
            superfundId
            isDisplayed
            displayName
            theme
            hideInDropDown
            umbrellaFundIds
            superFundPrefix
            adobeAnalyticsSuperfundMapping
        }# getSuperFundList
    }`;


export const SCAN_DOCUMENT_QUERY =
    `mutation UploadDocumentConfirmation($fileScanId: Int!, $claimId: Int!) {
        uploadDocumentConfirmation(fileScanId: $fileScanId, claimId: $claimId) {
            id
            scanStatus
            displayName
            documentIdentifier

        }
    }`;

export const GET_MEMBER_DATA_QUERY = `
query memberRecord {
    response: memberRecord {
        memberId
        memberNumber
        displayLegalDisclosure
        policyManagerId
        unReadDigiCorroMessageCount
        notificationPreference
        isDuplicatedMemberLocated
        claims {
            claimId
            claimNo
            caseNumber
            claimTypeName
            caseManager
            claimAssesmentStatus
            isLodgementTypeTele
            activities{
                claimPaymentId
                description
                title
                date
                type
                friendlyText
            }# activities
            requirements {
                id
                claimId
                description
                friendlyText
                requestedDate
                receivedDate
                completedDate
                associatedDocuments{
                    documentName
                    displayName
                    sharePointDocumentIdentifier
                    documentUploadDate
                }#associatedDocuments
            }# requirements
            details {
                sumInsured
                policyOwner
                claimSCBenefitPeriod
                claimSCWaitingPeriod
                masterPolicyNo
                monthlyBenefit
                lifeInsured
            }# details
            status{
                friendlyStatus  
                description
                tooltipText                  
                thirdPartyRequirementInfoText
                claimProgressStatusListForFund
            }# status
        }# claims
        documentsHistory{
            isSuccess
            value{
            claimId
            documentName
            documentUploadDate
            displayName
            isAssociatedRequirementFound
            sharePointDocumentIdentifier
            createdBy
            }#value
        }#documentsHistory
        profile{
            firstName
            fullName
            dateOfBirth
            email
            contactNumber
            address
        }#profile
        historicalPayments{
            paymentId
            claimCaseNumber
            benefitCaseNumber
            claimId
            claimType
            messageID
            paymentType
            paymentDate
            dateFrom
            dateTo
            grossAmount
            netAmount
            netOffsetAmount
            totalPaymentAmount
            benefitGroupId
            benefitPaymentDateFrom
            benefitPaymentDateTo
            adjustments{
                type
                amount
            }#Adjustments
            isRead
            createdTS
        }#historicalPayments
        scheduledPayments{
            scheduledPaymentId
            claimCaseNumber
            benefitCaseNumber
            claimId
            claimType
            messageID
            paymentDate
            dateFrom
            dateTo
            amount
            createdTS
        }#scheduledPayments
      }# getMemberRecord
  }`;

export const GET_MEMBER_NOTIFICATIONS_QUERY = `
query newNotifications {
    response: newNotifications {
        unreadCount
        list {
            notificationId
            claimId
            sourceId
            type
            title
            text
            createdOn
            readOn
        }#list
    }
}`;

export const GET_MEMBER_DOCUMENT_QUERY =`query downloadDocument($documentIdentifier: String!, $fileName: String!) {
    response: downloadDocument(documentIdentifier: $documentIdentifier, fileName: $fileName) {
        content
}}`;

export const GET_REFRESH_SESSION_QUERY = `
query refreshUserSession {
    refreshUserSession {
       success 
      }
  }`;

export const GET_LIST_OF_DIGICORRESPONDENCE_QUERY = `
query listDigiCorrespondences {
    listDigiCorrespondences{
        digiCorroId
        fineosClaimCaseNumber
        claimType
        documentTitle
        description
        classification
        createdOn
        isRead
    }
  }`;

export const GET_MEMBER_DIGICORRESPONDENCE_DOCUMENT_QUERY = `
query downloadDigiCorrospondenceDocument($digiCorroId: Int!) {
    downloadDigiCorrospondenceDocument(digiCorroId: $digiCorroId) {
        content
        fileName
    }
}`;
